import { Div, DivSkeleton, Flex, Grid } from '@fastnorth/kraken/components/layout';
import { Upload } from 'lucide-react';

type FilmstripSkeletonProps = {
  length?: number;
};

const FilmstripSkeleton = ({ length = 3 }: FilmstripSkeletonProps): React.JSX.Element => {
  const [, ...rest] = Array.from({ length });

  return (
    <Flex className={'flex flex-col gap-2 md:gap-7'}>
      <DivSkeleton className="w-full md:w-2/3 aspect-square self-center" grayVariant={300} />
      <Grid className={'grid-flow-col overflow-x-scroll pb-6 grid-cols-3 lg:pb-0 gap-2 md:gap-7'}>
        {rest.map((_, index) => (
          <DivSkeleton key={index} className="w-full aspect-square" grayVariant={100} />
        ))}
        <Div className={'w-full aspect-square flex items-center justify-center'}>
          <Upload className={'w-10 h-10'} />
        </Div>
      </Grid>
    </Flex>
  );
};

export default FilmstripSkeleton;
